import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SurveyService } from '@core/services/survey.service';
import { ParkingLotRating } from '@shared/constant/shared.constant';
import { ToastService } from '@shared/services/toast.service';
@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss']
})
export class SurveyComponent implements OnInit, OnDestroy{
  bookingId: string = '';
  bookingDetailds: any;
  isAlredyExist: boolean = true;
  surveyForm: FormGroup;
  isBookingDetailsAPIError: boolean = false;
  ratings = [
    { value: ParkingLotRating.DefinitelyWouldRecommend, label: '5 Definitely Would Recommend', emoji: '../../../assets/images/definitely-moji.svg', desc: 'Excellent experience; would confidently recommend to others.' },
    { value: ParkingLotRating.LikelytoRecommend, label: '4 Likely to Recommend', emoji: '../../../assets/images/unlikely-moji.svg', desc: 'Overall good experience; would recommend with minor reservations.' },
    { value: ParkingLotRating.Neutral, label: '3 Neutral', emoji: '../../../assets/images/neutral-moji.svg', desc: 'It was fine, but not great—might or might not recommend.' },
    { value: ParkingLotRating.UnlikelytoRecommend, label: '2 Unlikely to Recommend', emoji: '../../../assets/images/likely-moji.svg', desc: `Several issues; wouldn't feel comfortable referring someone.` },
    { value: ParkingLotRating.DefinitelyWouldNotRecommend, label: '1 Definitely Would Not Recommend', emoji: '../../../assets/images/definitely-not-moji.svg', desc: 'Had a very negative experience.' }
  ];
  constructor(
    private readonly surveyService: SurveyService,
    private readonly toastService: ToastService,
    private readonly formBuilder: FormBuilder,
    private readonly route: ActivatedRoute,
    private readonly renderer: Renderer2) { }

  ngOnInit() {
    this.bookingId = this.route.snapshot.paramMap.get('id') || '';
    this.surveyForm = this.formBuilder.group({
      rating: [null, Validators.required]
    });
    this.getBookingDetails();

  }

  getBookingDetails() {
    let requestData: any = {
      bookingId: this.bookingId
    };
    this.surveyService.parkingLotsBookingDetailsByID(requestData).subscribe({
      next: (response) => {
        this.bookingDetailds = response?.data;
        this.isAlredyExist = this.bookingDetailds?.isAlredyExist || false;
      },
      error: (_error) => {
        this.bookingDetailds = null;
        this.isBookingDetailsAPIError = true;
      }
    });
  }

getFeedbackMessage(): { img: string; title: string; subtitle?: string; cssClass?: string } | null {
  if (!this.bookingDetailds && !this.isBookingDetailsAPIError) {
    return null;
  }

  if (this.isBookingDetailsAPIError) {
    this.renderer.addClass(document.body, 'survey-body-scroll');
    return {
      img: '../../../assets/images/survey-link-vaild.svg',
      title: 'This survey link doesn’t appear to be valid.',
      subtitle: 'Please check and try again or contact support.',
      cssClass: 'survey-link-valid'
    };
  }

  if (this.bookingDetailds?.isAlredyExist) {
    this.renderer.addClass(document.body, 'survey-body-scroll');
    return {
      img: '../../../assets/images/survey-submitted.svg',
      title: 'This survey has been submitted.',
      subtitle: 'Thank you for your feedback!'
    };
  }

  return null;
}

selectFeedback(rating: ParkingLotRating) {
    this.surveyForm.get('rating')?.setValue(rating);
  }

  addSurvey() {
    let request = {
      userId: this.bookingDetailds?.userId,
      parkingLotId: this.bookingDetailds?.parkingLotId,
      bookingId: this.bookingDetailds?.bookingId,
      parkingExperinceRating: this.surveyForm?.value?.rating,
    }

    this.surveyService.addSurvey(request).subscribe({
      next: (_response) => {
        this.getBookingDetails();
      },
      error: (error) => {
        this.toastService.showToastMessage('error', 'Error', error?.error?.message);
      }
    });
  }
  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'survey-body-scroll');
  }
}
